import React, {useCallback, useEffect, useState} from 'react';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import {i18n} from "translate/i18n";


import {getDashboardUsers} from "services/Users.service";
import {debounce} from 'lodash'
import api from "services/api";
import {useQuery} from "react-query";
import {getCharts} from "../../services/Charts.service";
import Loading from "../Loading";

import {allUnits} from 'utils/actions';
import {useUser} from "../../store/providers/app";

const stylesSelect = {
    menu: base => ({
        ...base,
        zIndex: 100
    })
}

export const SelectIndicator = ({handleOnChange = null, selected, changeSelect = null, yearReference}) => {

    const { user } = useUser();

    const getAsyncOptions = (inputText) => {

        let filter = user.profile === 7 ? `&status=finished&auditable=1` : '';

        let filterLang = user.profile === 6 ? `&language=en-US` : '';

        return api.get(`/indicators?q=${inputText}${filter}${filterLang}&year_reference=${yearReference}`)
            .then((response) => {

                return response.data.data.map((indicator) => ({
                    value: indicator.id,
                    title: indicator.titulo,
                    label: indicator.codigo + ' - '+ indicator.titulo + ' - '+ indicator.language+ '-'+ indicator.year_reference,
                    status: indicator.status,
                    language: indicator.language
                }));
            })
            .catch((error) => {
                console.log(JSON.stringify(error));
            });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const loadOptions = useCallback(
        debounce((inputText, callback) => {
            getAsyncOptions(inputText).then((options) => callback(options));
        }, 2000),
        []
    );

    return (

        <AsyncSelect
            placeholder={i18n.t('select.indicator')}
            noOptionsMessage={(e) => e.inputValue.length >= 3 ? i18n.t('select.notfound') : i18n.t('select.minletters')}
            loadingMessage={(e) => e.inputValue.length >= 3 ? i18n.t('select.loading') : i18n.t('select.minletters')}
            loadOptions={loadOptions}
            value={selected}
            cacheOptions
            name="indicators"
            onChange={handleOnChange ? handleOnChange : (e, action) => changeSelect(e, { action })}
            isClearable
            styles={stylesSelect}
        />
    );
}

export const SelectGoals = ({handleOnChange = null, selected, changeSelect = null}) => {

    const getAsyncOptions = (inputText) => {
        return api.get(`/goals?q=${inputText}`)
            .then((response) => {

                return response.data.data.map((indicator) => ({
                    value: indicator.id,
                    title: indicator.titulo,
                    label: indicator.codigo + '- '+ indicator.titulo_meta + '- '+ indicator.language,
                    status: indicator.status
                }));
            })
            .catch((error) => {
                console.log(JSON.stringify(error));
            });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const loadOptions = useCallback(
        debounce((inputText, callback) => {
            getAsyncOptions(inputText).then((options) => callback(options));
        }, 2000),
        []
    );

    return (

        <AsyncSelect
            placeholder={i18n.t('select.goal')}
            noOptionsMessage={(e) => e.inputValue.length >= 3 ? i18n.t('select.notfound') : i18n.t('select.minletters')}
            loadingMessage={(e) => e.inputValue.length >= 3 ? i18n.t('select.loading') : i18n.t('select.minletters')}
            loadOptions={loadOptions}
            value={selected}
            cacheOptions
            name="goals"
            onChange={handleOnChange ? handleOnChange : (e, action) => changeSelect(e, { action })}
            isClearable
            styles={stylesSelect}
        />
    );
}

export const SelectTags = ({items, selected, handleChange, name}) => {
    return (
        <Select
           // value={}
            defaultValue={selected}
            isMulti
            onChange={handleChange}
            options={items}
            name={name}
            placeholder={i18n.t('select.tag')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={stylesSelect}
        />
    );
}

export const SelectUnits = ({items, selected, handleChange, name}) => {
    return (
        <Select
            value={selected}
            isMulti
            onChange={handleChange}
            options={items}
            name={name}
            placeholder={i18n.t('select.tag')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={stylesSelect}
        />
    );
}

export const SelectUsers = ({onChangeUsers, defaultUser}) => {

    const [users, setUsers] = useState([]);

    useEffect(() => {
        const dataUsers = async () => {
            const response = await getDashboardUsers()
            createList(response)
        }

        dataUsers()
    }, []);

    const createList = (response = []) => {
        const newUsersList = response.map((user) => {
            return {value: user.id, label: user.username};
        })
        setUsers(newUsersList);
    }

    return (
        <Select
            onChange={onChangeUsers}
            options={users}
            defaultInputValue={defaultUser}
            name="users"
            placeholder={i18n.t('select.user')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={stylesSelect}
        />
    );
}

export const SelectUsersLog = ({onChangeUsers}) => {

    const [users, setUsers] = useState([]);

    useEffect(() => {
        const loadUsers = async () => {
            const response = await getDashboardUsers();

            if(response?.data.length) {
                createList(response.data)
            }
        }
        loadUsers()
    }, []);

    const createList = (response = []) => {
        const newUsersList = response.map((user) => {
            return {value: user.id, label: user.username};
        })

        setUsers(newUsersList);
    }

    return (
        <Select
            onChange={onChangeUsers}
            options={users}
            isClearable={true}
            name="usersLogs"
            placeholder={i18n.t('select.user')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={stylesSelect}
        />
    );
}


export const SelectUsersIndicator = ({onChangeUser, profile, name, isMulti, defaultValues}) => {

    const [users, setUsers] = useState([]);

    useEffect(() => {
        (async () => {
            const response = await getDashboardUsers(false, 1, profile)
            createList(response)
        })();
    }, [profile]);

    const createList = (response = []) => {
        const newUsersList = response.map((user) => {
            return {value: user.id, label: user.username};
        })
        setUsers(newUsersList);
    }

    return (
        <Select
            defaultValue={defaultValues}
            onChange={onChangeUser}
            options={users}
            name={name}
            placeholder="Selecione ou busque o usuário"
            noOptionsMessage={() => "Nenhum usuário encontrado"}
            styles={stylesSelect}
            isMulti={isMulti}
        />
    );
}



export const SelectUsersForm = ({onChangeUser, profile, name, nameId, nameDb, oldName}) => {

    const [users, setUsers] = useState([]);

    useEffect(() => {
        const Request = async () => {
            const response = await getDashboardUsers(false, '', profile)
            createList(response)
        }

        Request().then(() => {})

    }, []);

    const createList = (response = []) => {
        const newUsersList = response.map((user) => {
            return {value: user.id, label: user.username};
        })
        setUsers(newUsersList);
    }

    return (
        <Select
            onChange={(e) => {
                onChangeUser(name, e.label);
                onChangeUser(nameId, e.value);
                onChangeUser(oldName, nameDb);
            }}
            options={users}
            defaultInputValue={nameDb}
            name={name}
            placeholder={i18n.t('select.user')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={stylesSelect}
        />
    );
}

export const SelectGraphic = ({handleChange, id, setSelectedGraphics}) => {

    const graphicOptions = [
        {label: 'Area', value: 'Area', new: true},
        {label: 'Coluna', value: 'Coluna', new: true},
        {label: 'Coluna empilhada', value: 'Coluna empilhada', new: true},
        {label: 'Linha', value: 'Linha', new: true},
        {label: 'Pizza', value: 'Pizza', new: true},
        //{label: 'Bolhas', value: 'Bolhas', new: true},
    ]

    const[optionsDefault, setOptionsDefault] = useState([])

    const {isFetching} = useQuery(['charts', id],
        () => {
            return getCharts(id)
        }, {
            onSuccess: (res) => {
                const response = res.data
                const optionsDefault = response.map(item => ({
                    value: item.type, label: item.type, isFixed: true
                }))
                setSelectedGraphics(optionsDefault)
                setOptionsDefault(optionsDefault)
            },
            retry: 2,
            refetchOnWindowFocus: false,
            retryOnMount: false
        }
    )

    const styles = {
        multiValue: (base, state) => {
            return state.data.isFixed ? {...base, backgroundColor: 'gray'} : base;
        },
        multiValueLabel: (base, state) => {
            return state.data.isFixed
                ? {...base, fontWeight: 'bold', color: 'white', paddingRight: 6}
                : base;
        },
        multiValueRemove: (base, state) => {
            return state.data.isFixed ? {...base, display: 'none'} : base;
        },
    };

    if(isFetching) return <Loading/>

    return (
        <Select
            onChange={handleChange}
            defaultValue={optionsDefault}
            isMulti
            options={graphicOptions}
            name="graphics"
            placeholder={i18n.t('select.graphic')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={styles}
            isClearable={false}
        />
    );
}

export const SelectUnit = ({units, onChangeUnits, position}) => {

    let optionsDefault = ''

    if(units) {
        optionsDefault = units.split(';').map(opt => (
            {
                label: opt.trim(),
                value: opt.trim()
            }
        ))
    }

    return (
        <Select
            onChange={(e, action) => onChangeUnits(e, { action }, position)}
            defaultValue={optionsDefault}
            isMulti
            options={allUnits}
            name="unit_convert"
            placeholder={i18n.t('label.select')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={stylesSelect}
        />
    )
}

export const SelectPrincipalUnit = ({unit, onChangeUnits, position, rowPosition}) => {

    let optionsDefault = ''

    if(unit) {
        optionsDefault =
            {
                label: unit,
                value: unit
            }
    }
    return (
        <Select
            onChange={(e, action) => onChangeUnits(e, { action }, position, rowPosition)}
            defaultValue={optionsDefault}
            value={{
                label: unit ? unit : '',
                value: unit ? unit : ''
            }}
            options={allUnits}
            name="unit_convert"
            placeholder={i18n.t('label.select')}
            noOptionsMessage={() => i18n.t('select.notfound')}
            styles={stylesSelect}
        />
    )
}
